import React, { Component } from "react";
import PropTypes from "prop-types";
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, withStyles } from "@material-ui/core";

const styles = (theme) => ({
  content: {
    minWidth: "300px",
  },
});

class ExcelEmailDialog extends Component {

    render() {
        const { classes, handleClose, callback, open, title, content } = this.props;
        return (
            <Dialog onClose={handleClose} aria-labelledby="Save User" open={open} maxWidth="sm">
                <DialogTitle>{title? title: "Info"} </DialogTitle>
                <DialogContent className={classes.content}>
                    {content? content: "Success"}
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => callback()}>OK</Button>
                </DialogActions>
            </Dialog>
        );
    }
}

ExcelEmailDialog.propTypes = {
    handleClose: PropTypes.func.isRequired,
    open: PropTypes.bool.isRequired,
    callback: PropTypes.func.isRequired,
    title: PropTypes.string,
    content: PropTypes.string,
};

export default withStyles(styles)(ExcelEmailDialog);
